import React from "react";
import SEO from "../components/SEO";
import Breadcrumb from "../components/Breadcrumb";
import FundingLabWelcomeArea from "../components/FundingLabWelcomeArea";
import FooterFour from "../components/FooterFour";
import NavBarThree from "../components/NavbarThree";

const FundingLabWelcome = () => {
  return (
    <>
      <SEO
        title="Welcome to Funding Lab"
        description="Payment confirmation for your Funding Lab enrollment."
        canonical="/fundinglab/welcome"
        noindex={true}
      />
      <NavBarThree />
      <Breadcrumb title={"Welcome to Funding Lab"} />
      <FundingLabWelcomeArea />
      <FooterFour />
    </>
  );
};

export default FundingLabWelcome;
